import { render, staticRenderFns } from "./EditFooter.vue?vue&type=template&id=a96fef62&scoped=true"
import script from "./EditFooter.vue?vue&type=script&lang=js"
export * from "./EditFooter.vue?vue&type=script&lang=js"
import style0 from "./EditFooter.vue?vue&type=style&index=0&id=a96fef62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96fef62",
  null
  
)

export default component.exports